import { createTheme, ThemeProvider } from '@mui/material/styles';
import { huHU as datePickerHu } from '@mui/x-date-pickers/locales';
import { huHU as coreHu } from '@mui/material/locale';
import { useTenant } from '../contexts/TenantContext';
import { useEffect } from 'react';

const DynamicThemeProvider = ({ children }) => {
  const { tenant, displayConfig } = useTenant();

  const theme = createTheme(
    {
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 900,
          lg: 1200,
          xl: 1536,
          xxl: 1920,
          xxxl: 2560,
        },
      },
      background: displayConfig?.background || "#fff",
      typography: {
        fontFamily: displayConfig?.fontFamily || "'Roboto', sans-serif",
      },
      palette: {
        primary: {
          main: displayConfig?.primaryColor || "#000",
        }
      },
    },
    datePickerHu,
    coreHu
  );

  const changeFavicon = (url) => {
    const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = url;
    if (!document.head.contains(link)) {
      document.head.appendChild(link);
    }
  };

  useEffect(() => {
    changeFavicon(`/${tenant?.tenantId}/favicon.ico`);
    document.title = tenant?.name || "DABS";
  }, [tenant]);

  useEffect(() => {
    if (!displayConfig?.fontFamily) return;
    const fontName = displayConfig.fontFamily.split(",")[0].replace(/'/g, "").trim();
    const existingLink = document.querySelector(`link[data-font="${fontName}"]`);
    if (existingLink) return;

    const link = document.createElement('link');
    link.rel = "stylesheet";
    link.setAttribute('data-font', fontName);
    link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(/ /g, "+")}:wght@400;700;900&display=swap`;
    document.head.appendChild(link);
  }, [displayConfig?.fontFamily]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default DynamicThemeProvider;